import { defineComponent as _defineComponent } from 'vue'
import { inject } from "vue";
import { ApiValidationErrorViewModel } from "@/viewModels/apiErrorViewModel";
import { CommunityTalkStore, isValidCommunityTalkStoreKey } from "@/store/communityTalk/communityTalkStore";
import CustomLabel from "./CustomLabel.vue";
import PostReviewerAttributeItem from "./PostReviewerAttributeItem.vue";

interface Props {
	/**
	 * CommunityTalkStoreのInject用キー。
	 */
	communityTalkStoreKey: string;
	/**
	 * 入力欄を無効化するかどうか。
	 */
	disabled?: boolean;
	/**
	 * 親コンポーネントからのAPIエラーオブジェクト。
	 */
	apiValidationErrorViewModel: ApiValidationErrorViewModel | null;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    communityTalkStoreKey: { type: String, required: true },
    disabled: { type: Boolean, required: false },
    apiValidationErrorViewModel: { type: null, required: true }
  },
  setup(__props: any, { expose }) {
  expose()

const props = __props as {
	/**
	 * CommunityTalkStoreのInject用キー。
	 */
	communityTalkStoreKey: string;
	/**
	 * 入力欄を無効化するかどうか。
	 */
	disabled?: boolean;
	/**
	 * 親コンポーネントからのAPIエラーオブジェクト。
	 */
	apiValidationErrorViewModel: ApiValidationErrorViewModel | null;
}
/**
 * 投稿者プロフィール投稿フォーム用。
 */


// Storeの初期化処理
if (!isValidCommunityTalkStoreKey(props.communityTalkStoreKey)) {
	// なんらかの原因でInjectKeyにエラーが発生していた場合は強制終了
	throw new Error(`InjectKeyにエラーが発生しました。${props.communityTalkStoreKey.toString()}`);
}
const communityTalkStore = inject(props.communityTalkStoreKey) as CommunityTalkStore;

/**
 * 投稿者プロフィール選択時の処理。
 */
const checkReviewerAttrChoice = (v: { reviewerAttributeId: string; attributeChoiceId: string; checked: boolean }) => {
	// Storeから更新前の投稿者プロフィール情報を取得
	let reviewerAttributeAnswers = communityTalkStore.getCommunityTalkUserReviewerAttributes();

	// 他の選択肢を選択している場合、回答から削除
	reviewerAttributeAnswers = communityTalkStore.getCommunityTalkUserReviewerAttributes().filter((x) => x.ReviewerAttributeId !== v.reviewerAttributeId);

	// 回答に追加
	if (v.checked) {
		reviewerAttributeAnswers.push({
			ReviewerAttributeId: v.reviewerAttributeId,
			AttributeChoiceIds: [v.attributeChoiceId],
		});
	}
	// Storeへ投稿者プロフィール情報を反映
	communityTalkStore.setCommunityTalkUserReviewerAttributes(reviewerAttributeAnswers);
};

// inputタグのID値を分別化するための固有識別子ID
const uniqueKey = crypto.randomUUID();

const __returned__ = { props, communityTalkStore, checkReviewerAttrChoice, uniqueKey, CustomLabel, PostReviewerAttributeItem }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})